module.exports = __webpack_public_path__ + "static/media/hairGod.2a4c8d36.jpg";